import React, { useState, useEffect,useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { GoThumbsup } from "react-icons/go";

import logo1 from '../../../assets/images/builders/logos/logo1.png'
import logo2 from '../../../assets/images/builders/logos/logo2.svg'
import logo3 from '../../../assets/images/builders/logos/logo3.webp'
import bannerImg1 from '../../../assets/images/builders/builderBanner/img1.webp'
import bannerImg2 from '../../../assets/images/builders/builderBanner/img2.webp'
import bannerImg3 from '../../../assets/images/builders/builderBanner/img3.webp'
import emptyAgent from '../../../assets/images/emptyAgent.mp4'
import builderAvatar from '../../../assets/images/icon/builderAvatar.mp4'

import BuilderBanner from '../../banner/builderBanner';
import axios from 'axios';
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';
import { LoginPopupContext } from '../../loginpopup/LoginPopupContext';
import { RoleContext } from '../../pages/Userdatacontext/Datacontexts'; 
import { useDispatch, useSelector } from "react-redux";
import { fetchUserDetails } from '../../slice/userSlice';
const path = "/keralaplots/";

function Builders() {

    // skelly loader
    const [isLoading, setIsLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);

    useEffect(() => {
        setIsLoading(false);
        fetchwebsitedetails();
    }, []);

    const [websiteDetails,setwebsiteDetails]=useState([]);

    const fetchwebsitedetails = async () => {
        const login_id = localStorage.getItem('login_id');
        try {
            const response = await axios.post(`${baseURL}/website/fetchwebsitedetails`, {
                login_id: login_id,
            });
            console.log(response.data);
    
            if (response.data && response.data.length > 0) {
                console.log(response.data)
                setwebsiteDetails(response.data);
            } else {
            }
    
        } catch (error) {
            console.error(error);
        }
    };

    const { updateRole } = useContext(RoleContext);
    const dispatch = useDispatch();
const handleBuilderClick = async(e) => {
        e.preventDefault();
        const token = localStorage.getItem('jwtToken');
        const login_id = localStorage.getItem('login_id');
       const selectedRole='Builder';
        if (!token) {
            setIsPopupVisible(true);
            return;
        }
    else{
        try {
            const response = await axios.post(`${baseURL}/updateprofile`, {
                login_id: login_id,
                role_val:selectedRole,
            });
            localStorage.setItem('roleval', selectedRole);
            updateRole(selectedRole);
            dispatch(fetchUserDetails(login_id));
       }
         catch (error) {
    }
        setShowPopup(true)
    }
};

  return (
    <>

    {/* confirmation popup */}
    {showPopup && (
    <div className="confirmationPopup">
        <div className="confirmationPopupBox">
            <div className="confirmationPopupBoxThumbnail">
                <video
                    playsInline
                    preload="auto"
                    autoPlay
                    muted
                    loop
                >
                    <source src={builderAvatar} type="video/mp4" />
                </video>
            </div>
            <div className="confirmationPopupBoxDetails">
                <h3>Congratulations <GoThumbsup /></h3>
                <p>Now you'r become a builder.</p>
                <div className="confirmationPopupBtn" onClick={() => setShowPopup(false)}>Okey</div>
            </div>
        </div>
    </div>
    )}

        <section id="builderPage">
        {isLoading ? (
            <div className='SkeletonLoader'>
                <div className='SkeletonLoaderBox'>
                    <Skeleton />
                </div>
            </div>
        ) : (
            <>
                <BuilderBanner />
            </>
        )}
            <div className="container">
                <div className="becomeBuilderStrip">
                    <div className="becomeBuilderStripCol1">
                        <h2 className="title">Join Us as a Trusted Builder</h2>
                        <p>Partner with us to showcase your projects, reach potential buyers, and grow your business. Join our platform and become a trusted builder today.</p>
                    </div>
                    <div className="becomeBuilderStripCol2">
                        <a href="" onClick={handleBuilderClick}>Become a Builder</a>
                    </div>
                </div>
                <div className="builderPageList">
                {isLoading ? (
                    <div className='SkeletonLoader2'>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <Skeleton />
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <Skeleton />
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <Skeleton />
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <Skeleton />
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <Skeleton />
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <Skeleton />
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                    {websiteDetails.map((builder, index) => (
                    <a href={`${path}${builder.company_name}`} target='_blank' className="builderPageBox">
                        <div className="builderPageBoxThumbnail">
                            <img src={mediaUrl+builder.image} alt="" />
                        </div>
                        <div className="builderPageBoxDetails">
                            <div className="builderPageBoxDetailsCol1">
                                <div className="builderPageBoxProfileImg">
                                    <img src={mediaUrl+builder.logo_image} alt="" />
                                </div>
                                <div className="builderPageBoxProfileName">
                                    <h3>{builder.company_name}</h3>
                                    <div className="builderPageBoxProfileNameStrip">
                                        <div className="exp">
                                            <h4>{builder.experience_val}</h4>
                                            <p>Experince</p>
                                        </div>
                                        <div className="propertyCount">
                                            <h4>{builder.total_properties}</h4>
                                            <p>Properties</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    ))}
                    {/* <a href={`${path}innerBuilders`} target='_blank' className="builderPageBox">
                        <div className="builderPageBoxThumbnail">
                            <img src={bannerImg1} alt="" />
                        </div>
                        <div className="builderPageBoxDetails">
                            <div className="builderPageBoxDetailsCol1">
                                <div className="builderPageBoxProfileImg">
                                    <img src={logo2} alt="" />
                                </div>
                                <div className="builderPageBoxProfileName">
                                    <h3>Asset Homes Private Limited</h3>
                                    <div className="builderPageBoxProfileNameStrip">
                                        <div className="exp">
                                            <h4>10</h4>
                                            <p>Experince</p>
                                        </div>
                                        <div className="propertyCount">
                                            <h4>24</h4>
                                            <p>Properties</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={`${path}innerBuilders`} target='_blank' className="builderPageBox">
                        <div className="builderPageBoxThumbnail">
                            <img src={bannerImg3} alt="" />
                        </div>
                        <div className="builderPageBoxDetails">
                            <div className="builderPageBoxDetailsCol1">
                                <div className="builderPageBoxProfileImg">
                                    <img src={logo3} alt="" />
                                </div>
                                <div className="builderPageBoxProfileName">
                                    <h3>Dreamflower Builders</h3>
                                    <div className="builderPageBoxProfileNameStrip">
                                        <div className="exp">
                                            <h4>10</h4>
                                            <p>Experince</p>
                                        </div>
                                        <div className="propertyCount">
                                            <h4>24</h4>
                                            <p>Properties</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={`${path}innerBuilders`} target='_blank' className="builderPageBox">
                        <div className="builderPageBoxThumbnail">
                            <img src={bannerImg2} alt="" />
                        </div>
                        <div className="builderPageBoxDetails">
                            <div className="builderPageBoxDetailsCol1">
                                <div className="builderPageBoxProfileImg">
                                    <img src={logo1} alt="" />
                                </div>
                                <div className="builderPageBoxProfileName">
                                    <h3>Kairali Builders</h3>
                                    <div className="builderPageBoxProfileNameStrip">
                                        <div className="exp">
                                            <h4>10</h4>
                                            <p>Experince</p>
                                        </div>
                                        <div className="propertyCount">
                                            <h4>24</h4>
                                            <p>Properties</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={`${path}innerBuilders`} target='_blank' className="builderPageBox">
                        <div className="builderPageBoxThumbnail">
                            <img src={bannerImg1} alt="" />
                        </div>
                        <div className="builderPageBoxDetails">
                            <div className="builderPageBoxDetailsCol1">
                                <div className="builderPageBoxProfileImg">
                                    <img src={logo2} alt="" />
                                </div>
                                <div className="builderPageBoxProfileName">
                                    <h3>Asset Homes Private Limited</h3>
                                    <div className="builderPageBoxProfileNameStrip">
                                        <div className="exp">
                                            <h4>10</h4>
                                            <p>Experince</p>
                                        </div>
                                        <div className="propertyCount">
                                            <h4>24</h4>
                                            <p>Properties</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={`${path}innerBuilders`} target='_blank' className="builderPageBox">
                        <div className="builderPageBoxThumbnail">
                            <img src={bannerImg3} alt="" />
                        </div>
                        <div className="builderPageBoxDetails">
                            <div className="builderPageBoxDetailsCol1">
                                <div className="builderPageBoxProfileImg">
                                    <img src={logo3} alt="" />
                                </div>
                                <div className="builderPageBoxProfileName">
                                    <h3>Dreamflower Builders</h3>
                                    <div className="builderPageBoxProfileNameStrip">
                                        <div className="exp">
                                            <h4>10</h4>
                                            <p>Experince</p>
                                        </div>
                                        <div className="propertyCount">
                                            <h4>24</h4>
                                            <p>Properties</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a> */}
                    </>
                )}
                <div className="emptyPage" style={{display: 'none'}}>
                  <div className="container">
                    <div className="emptyPageMain">
                      <div className="emptyPageBoxThumbnail">
                        <video
                            playsInline
                            preload="auto"
                            autoPlay
                            muted
                            loop
                        >
                            <source src={emptyAgent} type="video/mp4" />
                        </video>
                      </div>
                      <div className="emptyPageBoxDetails">
                        <h2 className="title">Builders not available</h2>
                        <p>Builders are currently unavailable to assist you. Please leave a message or check back later. We appreciate your patience and will respond as soon as possible.</p>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
        </section>
    </>
  );
}

export default Builders;
